import type { Priority, Task, TaskType } from './types'

export type TaskFilters = {
  type: TaskType | 'all'
  installationId: string | 'all'
  assigneeId: string | 'all' | 'none'
  priority: Priority | 'all'
  sprint: string | 'all'
  q: string
}

export const EMPTY_FILTERS: TaskFilters = { type: 'all', installationId: 'all', assigneeId: 'all', priority: 'all', sprint: 'all', q: '' }

export function applyTaskFilters(tasks: Task[], f: TaskFilters) {
  const term = f.q.trim().toLocaleLowerCase('tr')
  return tasks.filter(
    (t) =>
      (f.type === 'all' || t.type === f.type) &&
      (f.installationId === 'all' || t.installationId === f.installationId) &&
      (f.assigneeId === 'all' || (f.assigneeId === 'none' ? !t.assigneeId : t.assigneeId === f.assigneeId)) &&
      (f.priority === 'all' || t.priority === f.priority) &&
      (f.sprint === 'all' || t.sprint === f.sprint) &&
      (!term || `${t.key} ${t.title} ${t.description}`.toLocaleLowerCase('tr').includes(term)),
  )
}

export const hasActiveFilters = (f: TaskFilters) => JSON.stringify(f) !== JSON.stringify(EMPTY_FILTERS)

/** Bugünün yerel tarihi (yyyy-MM-dd). */
export const todayIso = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export const isOverdue = (t: Pick<Task, 'dueDate' | 'status'>) => t.status !== 'done' && !!t.dueDate && t.dueDate < todayIso()

export function fmtSize(bytes: number) {
  if (bytes < 1024) return `${bytes} B`
  const units = ['KB', 'MB', 'GB']
  let v = bytes / 1024
  let i = 0
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024
    i += 1
  }
  return `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 1 }).format(v)} ${units[i]}`
}
